var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnrr = function SvgEnrr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.498 0v2c0 9.627-5.372 14-12 14H2.741a17 17 0 0 0-.243 3h-2c0-1.363.116-2.6.346-3.732Q.498 13.327.498 10c0-5.523 4.477-10 10-10 2 0 4 1 8 0m-8 2a8 8 0 0 0-8 8q0 .543.01 1.046c1.254-1.978 3.091-3.541 5.494-4.914l.992 1.736C6.14 9.5 4.246 11.353 3.274 14h3.224c6.015 0 9.871-3.973 9.997-11.612-1.372.133-2.647.048-4.22-.188-1.15-.173-1.376-.2-1.777-.2"
  })));
};
export default SvgEnrr;